import React from "react";

export default function HybrideDescription({ className }) {
  return (
    <svg
      width="105"
      height="35"
      viewBox="0 0 110 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="1.18359"
        width="105"
        height="33"
        rx="16.5"
        fill="#29394D"
        fill-opacity="0.7"
        stroke="white"
      />
      <g clip-path="url(#clip0_3640_120874)">
        <path
          d="M13.3333 23.6836H11.6667C11.4459 23.6829 11.2344 23.5955 11.0783 23.4405C10.9221 23.2854 10.8341 23.0753 10.8335 22.856V19.9595C10.6127 19.9588 10.4011 19.8714 10.245 19.7163C10.0889 19.5613 10.0009 19.3512 10.0002 19.1319V16.6491C9.99721 16.4853 10.0275 16.3225 10.0892 16.1706C10.151 16.0186 10.243 15.8806 10.3596 15.7647C10.4763 15.6488 10.6153 15.5575 10.7683 15.4962C10.9213 15.4348 11.0851 15.4048 11.2501 15.4077H13.7499C13.9149 15.4048 14.0787 15.4348 14.2317 15.4962C14.3847 15.5575 14.5237 15.6488 14.6404 15.7647C14.757 15.8806 14.849 16.0186 14.9108 16.1706C14.9725 16.3225 15.0028 16.4853 14.9998 16.6491V19.1319C14.9991 19.3512 14.9111 19.5613 14.755 19.7163C14.5989 19.8714 14.3873 19.9588 14.1665 19.9595V22.856C14.1659 23.0753 14.0779 23.2854 13.9217 23.4405C13.7656 23.5955 13.5541 23.6829 13.3333 23.6836ZM12.5 14.9939C12.1704 14.9939 11.8482 14.8969 11.5741 14.715C11.3001 14.5331 11.0865 14.2746 10.9603 13.9722C10.8342 13.6697 10.8012 13.3369 10.8655 13.0159C10.9298 12.6948 11.0885 12.3999 11.3216 12.1684C11.5547 11.9369 11.8516 11.7793 12.1749 11.7154C12.4982 11.6515 12.8332 11.6843 13.1378 11.8096C13.4423 11.9349 13.7025 12.147 13.8857 12.4192C14.0688 12.6914 14.1665 13.0114 14.1665 13.3388C14.1654 13.7774 13.9895 14.1978 13.6772 14.5079C13.3649 14.8181 12.9417 14.9928 12.5 14.9939Z"
          fill="white"
        />
        <g clip-path="url(#clip1_3640_120874)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19 22.6836C19.6566 22.6836 20.3068 22.5543 20.9134 22.303C21.52 22.0517 22.0712 21.6834 22.5355 21.2191C22.9998 20.7548 23.3681 20.2036 23.6194 19.597C23.8707 18.9904 24 18.3402 24 17.6836C24 17.027 23.8707 16.3768 23.6194 15.7702C23.3681 15.1635 22.9998 14.6124 22.5355 14.1481C22.0712 13.6838 21.52 13.3155 20.9134 13.0642C20.3068 12.8129 19.6566 12.6836 19 12.6836C17.6739 12.6836 16.4021 13.2104 15.4645 14.1481C14.5268 15.0857 14 16.3575 14 17.6836C14 19.0097 14.5268 20.2814 15.4645 21.2191C16.4021 22.1568 17.6739 22.6836 19 22.6836ZM18.3239 15.4558L21.4594 17.198C21.546 17.2462 21.6181 17.3166 21.6683 17.4019C21.7186 17.4873 21.745 17.5845 21.745 17.6836C21.745 17.7826 21.7186 17.8799 21.6683 17.9653C21.6181 18.0506 21.546 18.121 21.4594 18.1691L18.3239 19.9114C18.2224 19.9678 18.1078 19.9967 17.9917 19.9953C17.8756 19.9938 17.7618 19.9621 17.6617 19.9031C17.5616 19.8442 17.4787 19.7601 17.4211 19.6592C17.3635 19.5584 17.3332 19.4442 17.3333 19.328V16.0391C17.3332 15.923 17.3635 15.8088 17.4211 15.7079C17.4787 15.6071 17.5616 15.523 17.6617 15.4641C17.7618 15.4051 17.8756 15.3733 17.9917 15.3719C18.1078 15.3705 18.2224 15.3994 18.3239 15.4558Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3640_120874">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(10 10.6836)"
          />
        </clipPath>
        <clipPath id="clip1_3640_120874">
          <rect
            width="8"
            height="10"
            fill="white"
            transform="translate(16 12.6836)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
